import styled from "@emotion/styled";
import { Button as LoadingButton } from "@mui/material";

export const ConfirmationMessageWrapper = styled("div")`
  text-align: center;
  margin: 16px 0;
`;
export const ConfirmationCenteredButton = styled(LoadingButton)`
  margin: 0 auto;
`;
